import { render, staticRenderFns } from "./TipoAtividade.vue?vue&type=template&id=449035a1&"
import script from "./TipoAtividade.vue?vue&type=script&lang=js&"
export * from "./TipoAtividade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports